export default {
  pt: {
    'acoesEmMassa.reag.busca': 'Buscar motorista, placa ou carga',
    'acoesEmMassa.reag.buscaConjunto': 'Buscar motorista ou placa',
    'acoesEmMassa.reag.selecionarTodas': 'Selecionar todas',
    'acoesEmMassa.reag.limparSelecao': 'Limpar seleção',
    'acoesEmMassa.reag.selecionadas': 'Selecionadas',
    'acoesEmMassa.reag.disponiveis': 'Selecionáveis',
    'acoesEmMassa.reag.foraDaLista': 'Descarregando ou encerradas',
    'acoesEmMassa.reag.foraDaListaDica': 'Entram viagens sem etapa, Escaladas, Carregando e Em trânsito. As que já começaram mudam só o início.',
    'acoesEmMassa.reag.nenhumaElegivel': 'Nenhuma viagem desta frente pode ser reagendada agora. Só entram viagens sem etapa, Escaladas, Carregando ou Em trânsito.',
    'acoesEmMassa.reag.nenhumaNaBusca': 'Nenhuma viagem casa com a busca.',
    'acoesEmMassa.reag.semData': 'Sem data',
    'acoesEmMassa.reag.semMotorista': 'Sem motorista',
    'acoesEmMassa.reag.outraTransportadora': 'Outra transportadora',
    'acoesEmMassa.reag.escalado': 'Escalado',
    'acoesEmMassa.reag.etapaCarregando': 'Carregando',
    'acoesEmMassa.reag.etapaTransito': 'Em trânsito',
    'acoesEmMassa.reag.semEscala': 'Sem escala',
    'acoesEmMassa.reag.limite': 'No máximo {{max}} viagens por vez.',
    'acoesEmMassa.reag.doDia': '{{selecionadas}} de {{total}}',
    'acoesEmMassa.reag.numero': 'Nº {{ordem}}',
    'acoesEmMassa.reag.carga': 'Carga {{numero}}',
    'acoesEmMassa.reag.selecionarDia': 'Selecionar as viagens do dia',
    'acoesEmMassa.reag.carregando': 'Carregando',
    'acoesEmMassa.reag.erroCarregar': 'Não foi possível carregar as viagens e os conjuntos.',
    'acoesEmMassa.reag.tentarDeNovo': 'Tentar de novo',
    'acoesEmMassa.reag.escolhaUma': 'Escolha ao menos uma viagem.',

    'acoesEmMassa.reag.deslocarTitulo': 'Horário de todas',
    'acoesEmMassa.reag.deslocarDica': 'A primeira viagem sai no início informado, e cada uma das seguintes sai um intervalo depois da anterior. Sem intervalo, todas andam juntas e o espaço entre elas fica como era. As ajustadas à mão ficam onde você deixou.',
    'acoesEmMassa.reag.zerar': 'Voltar ao original',
    'acoesEmMassa.reag.inicioPrimeira': 'Início da primeira',
    'acoesEmMassa.reag.intervalo': 'Intervalo',
    'acoesEmMassa.reag.intervaloDica': 'Vazio mantém o espaço atual',
    'acoesEmMassa.reag.faixaOriginal': 'Original',
    'acoesEmMassa.reag.faixaProposto': 'Proposto',
    'acoesEmMassa.reag.colViagem': 'Viagem',
    'acoesEmMassa.reag.colInicio': 'Início',
    'acoesEmMassa.reag.colMotorista': 'Motorista',
    'acoesEmMassa.reag.antes': 'Antes',
    'acoesEmMassa.reag.aMao': 'Ajustado à mão',
    'acoesEmMassa.reag.voltarAoColetivo': 'Voltar ao horário de todas',
    'acoesEmMassa.reag.inicioObrigatorio': 'Informe o início.',
    'acoesEmMassa.reag.noPassado': 'Início no passado',
    'acoesEmMassa.reag.farolVolta': 'A programação enviada volta a não enviada',
    'acoesEmMassa.reag.trocadoCom': 'Trocou de motorista com a viagem {{numero}}',
    'acoesEmMassa.reag.movidoPara': 'Motorista levado para a viagem {{numero}}',
    'acoesEmMassa.reag.arrastar': 'Arraste para outra viagem',
    'acoesEmMassa.reag.travado.outra_transportadora': 'Linha de outra transportadora. O motorista não muda aqui.',
    'acoesEmMassa.reag.travado.composicao': 'A composição foi trocada na linha. Mude o motorista pelo lápis da viagem.',
    'acoesEmMassa.reag.travado.fora_do_alcance': 'O conjunto desta viagem está fora da sua Dupla HUB.',
    'acoesEmMassa.reag.travado.iniciada': 'A viagem já começou. Aqui muda só o início; o motorista se troca pelo lápis da viagem.',
    'acoesEmMassa.reag.naViagem': 'Na viagem {{numero}}',
    'acoesEmMassa.reag.selecioneParaTrocar': 'Escalado na viagem {{numero}} desta frente. Selecione essa viagem para trocar.',
    'acoesEmMassa.reag.escaladoEm': 'Escalado na viagem {{numero}} do contrato {{contrato}}',
    'acoesEmMassa.reag.desfazerTudo': 'Desfazer tudo',
    'acoesEmMassa.reag.automatica': 'Escala automática',
    'acoesEmMassa.reag.automaticaDica': 'Reorganiza os conjuntos já escalados pelo Último Disponível: quem está vazio há mais tempo fica na primeira viagem. Nenhum conjunto entra ou sai.',
    'acoesEmMassa.reag.automaticaSemConjuntos': 'É preciso ao menos dois conjuntos escalados nas viagens selecionadas.',
    'acoesEmMassa.reag.automaticaOk': 'Conjuntos reorganizados pelo Último Disponível.',
    'acoesEmMassa.reag.automaticaJaEstava': 'Os conjuntos já estavam na ordem do Último Disponível.',
    'acoesEmMassa.reag.ultimoDisponivel': 'Último disponível {{quando}}',
    'acoesEmMassa.reag.semUltimoDisponivel': 'Último disponível não registrado',
    'acoesEmMassa.reag.alteracoes': 'Alterações',
    'acoesEmMassa.reag.semAlteracoes': 'Nenhuma alteração ainda.',
    'acoesEmMassa.reag.corrijaInicios': 'Informe o início das viagens marcadas.',
    'acoesEmMassa.reag.revisar': 'Revisar',
    'acoesEmMassa.reag.mudouDepois': 'Esta viagem mudou depois que você a escolheu. Ela será conferida ao aplicar.',
    'acoesEmMassa.reag.escolhaMotorista': 'Motorista da viagem',

    'acoesEmMassa.reag.revisaoTitulo': 'Confira antes de aplicar',
    'acoesEmMassa.reag.revisaoDica': 'Nada muda na Frente até você aplicar. Se qualquer viagem for recusada, nenhuma muda.',
    'acoesEmMassa.reag.viagensAlteradas': 'Viagens alteradas',
    'acoesEmMassa.reag.novosHorarios': 'Novos horários',
    'acoesEmMassa.reag.trocasDeMotorista': 'Trocas de motorista',
    'acoesEmMassa.reag.programacoesAReenviar': 'Programações a reenviar',
    'acoesEmMassa.reag.inicioNoPassado': 'Início no passado',
    'acoesEmMassa.reag.colAvisos': 'Avisos',
    'acoesEmMassa.reag.depois': 'Depois',
    'acoesEmMassa.reag.semMudanca': 'Sem mudança',
    'acoesEmMassa.reag.aplicar': 'Aplicar alterações',
    'acoesEmMassa.reag.sucesso': 'Viagens atualizadas: {{count}}.',
    'acoesEmMassa.reag.recusaTitulo': 'Nada foi alterado',
    'acoesEmMassa.reag.atualizarERevisar': 'Atualizar e revisar',
    'acoesEmMassa.reag.recusaDaViagem': 'Viagem {{numero}}',
  },
  en: {
    'acoesEmMassa.reag.busca': 'Search driver, plate or load',
    'acoesEmMassa.reag.buscaConjunto': 'Search driver or plate',
    'acoesEmMassa.reag.selecionarTodas': 'Select all',
    'acoesEmMassa.reag.limparSelecao': 'Clear selection',
    'acoesEmMassa.reag.selecionadas': 'Selected',
    'acoesEmMassa.reag.disponiveis': 'Selectable',
    'acoesEmMassa.reag.foraDaLista': 'Unloading or closed',
    'acoesEmMassa.reag.foraDaListaDica': 'Trips with no stage, Scheduled, Loading and In transit are listed. Started trips change only the start.',
    'acoesEmMassa.reag.nenhumaElegivel': 'No trip of this work front can be rescheduled now. Only trips with no stage, Scheduled, Loading or In transit are listed.',
    'acoesEmMassa.reag.nenhumaNaBusca': 'No trip matches the search.',
    'acoesEmMassa.reag.semData': 'No date',
    'acoesEmMassa.reag.semMotorista': 'No driver',
    'acoesEmMassa.reag.outraTransportadora': 'Another carrier',
    'acoesEmMassa.reag.escalado': 'Scheduled',
    'acoesEmMassa.reag.etapaCarregando': 'Loading',
    'acoesEmMassa.reag.etapaTransito': 'In transit',
    'acoesEmMassa.reag.semEscala': 'Not scheduled',
    'acoesEmMassa.reag.limite': 'At most {{max}} trips at a time.',
    'acoesEmMassa.reag.doDia': '{{selecionadas}} of {{total}}',
    'acoesEmMassa.reag.numero': 'No. {{ordem}}',
    'acoesEmMassa.reag.carga': 'Load {{numero}}',
    'acoesEmMassa.reag.selecionarDia': 'Select the trips of the day',
    'acoesEmMassa.reag.carregando': 'Loading',
    'acoesEmMassa.reag.erroCarregar': 'Could not load the trips and truck combinations.',
    'acoesEmMassa.reag.tentarDeNovo': 'Try again',
    'acoesEmMassa.reag.escolhaUma': 'Choose at least one trip.',

    'acoesEmMassa.reag.deslocarTitulo': 'Time of all trips',
    'acoesEmMassa.reag.deslocarDica': 'The first trip leaves at the start you enter, and each following one leaves one interval after the previous. Without an interval, all move together and keep the spacing they had. Trips adjusted by hand stay where you left them.',
    'acoesEmMassa.reag.zerar': 'Back to original',
    'acoesEmMassa.reag.inicioPrimeira': 'Start of the first',
    'acoesEmMassa.reag.intervalo': 'Interval',
    'acoesEmMassa.reag.intervaloDica': 'Empty keeps the current spacing',
    'acoesEmMassa.reag.faixaOriginal': 'Original',
    'acoesEmMassa.reag.faixaProposto': 'Proposed',
    'acoesEmMassa.reag.colViagem': 'Trip',
    'acoesEmMassa.reag.colInicio': 'Start',
    'acoesEmMassa.reag.colMotorista': 'Driver',
    'acoesEmMassa.reag.antes': 'Before',
    'acoesEmMassa.reag.aMao': 'Adjusted by hand',
    'acoesEmMassa.reag.voltarAoColetivo': 'Back to the time of all trips',
    'acoesEmMassa.reag.inicioObrigatorio': 'Enter the start.',
    'acoesEmMassa.reag.noPassado': 'Start in the past',
    'acoesEmMassa.reag.farolVolta': 'The sent schedule goes back to not sent',
    'acoesEmMassa.reag.trocadoCom': 'Swapped drivers with trip {{numero}}',
    'acoesEmMassa.reag.movidoPara': 'Driver moved to trip {{numero}}',
    'acoesEmMassa.reag.arrastar': 'Drag to another trip',
    'acoesEmMassa.reag.travado.outra_transportadora': 'Another carrier row. The driver does not change here.',
    'acoesEmMassa.reag.travado.composicao': 'The combination was changed on the row. Change the driver with the trip pencil.',
    'acoesEmMassa.reag.travado.fora_do_alcance': 'The combination of this trip is outside your HUB pair.',
    'acoesEmMassa.reag.travado.iniciada': 'The trip has already started. Only the start changes here; change the driver with the trip pencil.',
    'acoesEmMassa.reag.naViagem': 'On trip {{numero}}',
    'acoesEmMassa.reag.selecioneParaTrocar': 'Scheduled on trip {{numero}} of this work front. Select that trip to swap.',
    'acoesEmMassa.reag.escaladoEm': 'Scheduled on trip {{numero}} of contract {{contrato}}',
    'acoesEmMassa.reag.desfazerTudo': 'Undo all',
    'acoesEmMassa.reag.automatica': 'Auto schedule',
    'acoesEmMassa.reag.automaticaDica': 'Reorders the sets already scheduled by Last available: the one empty the longest takes the first trip. No set is added or removed.',
    'acoesEmMassa.reag.automaticaSemConjuntos': 'At least two scheduled sets are needed in the selected trips.',
    'acoesEmMassa.reag.automaticaOk': 'Sets reordered by Last available.',
    'acoesEmMassa.reag.automaticaJaEstava': 'The sets were already in Last available order.',
    'acoesEmMassa.reag.ultimoDisponivel': 'Last available {{quando}}',
    'acoesEmMassa.reag.semUltimoDisponivel': 'Last available not recorded',
    'acoesEmMassa.reag.alteracoes': 'Changes',
    'acoesEmMassa.reag.semAlteracoes': 'No changes yet.',
    'acoesEmMassa.reag.corrijaInicios': 'Enter the start of the marked trips.',
    'acoesEmMassa.reag.revisar': 'Review',
    'acoesEmMassa.reag.mudouDepois': 'This trip changed after you chose it. It will be checked when applying.',
    'acoesEmMassa.reag.escolhaMotorista': 'Trip driver',

    'acoesEmMassa.reag.revisaoTitulo': 'Check before applying',
    'acoesEmMassa.reag.revisaoDica': 'Nothing changes on the work front until you apply. If any trip is refused, none changes.',
    'acoesEmMassa.reag.viagensAlteradas': 'Changed trips',
    'acoesEmMassa.reag.novosHorarios': 'New times',
    'acoesEmMassa.reag.trocasDeMotorista': 'Driver changes',
    'acoesEmMassa.reag.programacoesAReenviar': 'Schedules to resend',
    'acoesEmMassa.reag.inicioNoPassado': 'Start in the past',
    'acoesEmMassa.reag.colAvisos': 'Warnings',
    'acoesEmMassa.reag.depois': 'After',
    'acoesEmMassa.reag.semMudanca': 'No change',
    'acoesEmMassa.reag.aplicar': 'Apply changes',
    'acoesEmMassa.reag.sucesso': 'Trips updated: {{count}}.',
    'acoesEmMassa.reag.recusaTitulo': 'Nothing was changed',
    'acoesEmMassa.reag.atualizarERevisar': 'Refresh and review',
    'acoesEmMassa.reag.recusaDaViagem': 'Trip {{numero}}',
  },
  es: {
    'acoesEmMassa.reag.busca': 'Buscar conductor, placa o carga',
    'acoesEmMassa.reag.buscaConjunto': 'Buscar conductor o placa',
    'acoesEmMassa.reag.selecionarTodas': 'Seleccionar todas',
    'acoesEmMassa.reag.limparSelecao': 'Limpiar selección',
    'acoesEmMassa.reag.selecionadas': 'Seleccionadas',
    'acoesEmMassa.reag.disponiveis': 'Seleccionables',
    'acoesEmMassa.reag.foraDaLista': 'Descargando o cerradas',
    'acoesEmMassa.reag.foraDaListaDica': 'Entran viajes sin etapa, Asignados, Cargando y En tránsito. Los que ya comenzaron cambian solo el inicio.',
    'acoesEmMassa.reag.nenhumaElegivel': 'Ningún viaje de este frente puede reprogramarse ahora. Solo entran viajes sin etapa, Asignados, Cargando o En tránsito.',
    'acoesEmMassa.reag.nenhumaNaBusca': 'Ningún viaje coincide con la búsqueda.',
    'acoesEmMassa.reag.semData': 'Sin fecha',
    'acoesEmMassa.reag.semMotorista': 'Sin conductor',
    'acoesEmMassa.reag.outraTransportadora': 'Otra transportadora',
    'acoesEmMassa.reag.escalado': 'Asignado',
    'acoesEmMassa.reag.etapaCarregando': 'Cargando',
    'acoesEmMassa.reag.etapaTransito': 'En tránsito',
    'acoesEmMassa.reag.semEscala': 'Sin asignar',
    'acoesEmMassa.reag.limite': 'Como máximo {{max}} viajes a la vez.',
    'acoesEmMassa.reag.doDia': '{{selecionadas}} de {{total}}',
    'acoesEmMassa.reag.numero': 'N.º {{ordem}}',
    'acoesEmMassa.reag.carga': 'Carga {{numero}}',
    'acoesEmMassa.reag.selecionarDia': 'Seleccionar los viajes del día',
    'acoesEmMassa.reag.carregando': 'Cargando',
    'acoesEmMassa.reag.erroCarregar': 'No fue posible cargar los viajes y los conjuntos.',
    'acoesEmMassa.reag.tentarDeNovo': 'Intentar de nuevo',
    'acoesEmMassa.reag.escolhaUma': 'Elija al menos un viaje.',

    'acoesEmMassa.reag.deslocarTitulo': 'Horario de todos',
    'acoesEmMassa.reag.deslocarDica': 'El primer viaje sale en el inicio informado, y cada uno de los siguientes sale un intervalo después del anterior. Sin intervalo, todos se mueven juntos y el espacio entre ellos queda como estaba. Los ajustados a mano quedan donde los dejó.',
    'acoesEmMassa.reag.zerar': 'Volver al original',
    'acoesEmMassa.reag.inicioPrimeira': 'Inicio del primero',
    'acoesEmMassa.reag.intervalo': 'Intervalo',
    'acoesEmMassa.reag.intervaloDica': 'Vacío mantiene el espacio actual',
    'acoesEmMassa.reag.faixaOriginal': 'Original',
    'acoesEmMassa.reag.faixaProposto': 'Propuesto',
    'acoesEmMassa.reag.colViagem': 'Viaje',
    'acoesEmMassa.reag.colInicio': 'Inicio',
    'acoesEmMassa.reag.colMotorista': 'Conductor',
    'acoesEmMassa.reag.antes': 'Antes',
    'acoesEmMassa.reag.aMao': 'Ajustado a mano',
    'acoesEmMassa.reag.voltarAoColetivo': 'Volver al horario de todos',
    'acoesEmMassa.reag.inicioObrigatorio': 'Informe el inicio.',
    'acoesEmMassa.reag.noPassado': 'Inicio en el pasado',
    'acoesEmMassa.reag.farolVolta': 'La programación enviada vuelve a no enviada',
    'acoesEmMassa.reag.trocadoCom': 'Intercambió conductor con el viaje {{numero}}',
    'acoesEmMassa.reag.movidoPara': 'Conductor llevado al viaje {{numero}}',
    'acoesEmMassa.reag.arrastar': 'Arrastre a otro viaje',
    'acoesEmMassa.reag.travado.outra_transportadora': 'Línea de otra transportadora. El conductor no cambia aquí.',
    'acoesEmMassa.reag.travado.composicao': 'La composición se cambió en la línea. Cambie el conductor con el lápiz del viaje.',
    'acoesEmMassa.reag.travado.fora_do_alcance': 'El conjunto de este viaje está fuera de su Dupla HUB.',
    'acoesEmMassa.reag.travado.iniciada': 'El viaje ya comenzó. Aquí cambia solo el inicio; el conductor se cambia con el lápiz del viaje.',
    'acoesEmMassa.reag.naViagem': 'En el viaje {{numero}}',
    'acoesEmMassa.reag.selecioneParaTrocar': 'Asignado en el viaje {{numero}} de este frente. Seleccione ese viaje para intercambiar.',
    'acoesEmMassa.reag.escaladoEm': 'Asignado en el viaje {{numero}} del contrato {{contrato}}',
    'acoesEmMassa.reag.desfazerTudo': 'Deshacer todo',
    'acoesEmMassa.reag.automatica': 'Escala automática',
    'acoesEmMassa.reag.automaticaDica': 'Reorganiza los conjuntos ya escalados por el Último disponible: el que está vacío hace más tiempo queda en el primer viaje. Ningún conjunto entra ni sale.',
    'acoesEmMassa.reag.automaticaSemConjuntos': 'Se necesitan al menos dos conjuntos escalados en los viajes seleccionados.',
    'acoesEmMassa.reag.automaticaOk': 'Conjuntos reorganizados por el Último disponible.',
    'acoesEmMassa.reag.automaticaJaEstava': 'Los conjuntos ya estaban en el orden del Último disponible.',
    'acoesEmMassa.reag.ultimoDisponivel': 'Último disponible {{quando}}',
    'acoesEmMassa.reag.semUltimoDisponivel': 'Último disponible no registrado',
    'acoesEmMassa.reag.alteracoes': 'Cambios',
    'acoesEmMassa.reag.semAlteracoes': 'Ningún cambio todavía.',
    'acoesEmMassa.reag.corrijaInicios': 'Informe el inicio de los viajes marcados.',
    'acoesEmMassa.reag.revisar': 'Revisar',
    'acoesEmMassa.reag.mudouDepois': 'Este viaje cambió después de que lo eligió. Se verificará al aplicar.',
    'acoesEmMassa.reag.escolhaMotorista': 'Conductor del viaje',

    'acoesEmMassa.reag.revisaoTitulo': 'Revise antes de aplicar',
    'acoesEmMassa.reag.revisaoDica': 'Nada cambia en el frente hasta que aplique. Si algún viaje es rechazado, ninguno cambia.',
    'acoesEmMassa.reag.viagensAlteradas': 'Viajes modificados',
    'acoesEmMassa.reag.novosHorarios': 'Nuevos horarios',
    'acoesEmMassa.reag.trocasDeMotorista': 'Cambios de conductor',
    'acoesEmMassa.reag.programacoesAReenviar': 'Programaciones a reenviar',
    'acoesEmMassa.reag.inicioNoPassado': 'Inicio en el pasado',
    'acoesEmMassa.reag.colAvisos': 'Avisos',
    'acoesEmMassa.reag.depois': 'Después',
    'acoesEmMassa.reag.semMudanca': 'Sin cambio',
    'acoesEmMassa.reag.aplicar': 'Aplicar cambios',
    'acoesEmMassa.reag.sucesso': 'Viajes actualizados: {{count}}.',
    'acoesEmMassa.reag.recusaTitulo': 'No se cambió nada',
    'acoesEmMassa.reag.atualizarERevisar': 'Actualizar y revisar',
    'acoesEmMassa.reag.recusaDaViagem': 'Viaje {{numero}}',
  },
}
